import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 跳转到登录页，避免在登录页重复跳转导致 NavigationDuplicated 报错
function redirectToLogin() {
  if (router.currentRoute.path !== '/login') {
    router.push('/login')
  }
}

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器 - 统一处理 { status, message, data } 格式
service.interceptors.response.use(
  response => {
    const res = response.data

    // OAuth2 登录成功返回 token (有 access_token 或 value 字段)
    if (res.access_token || res.value) {
      return res
    }

    // 统一响应格式 { status, message, data }
    if (res.status !== undefined) {
      if (res.status === 1000) {
        return res.data !== undefined ? res.data : res
      } else if (res.status === 1002 || res.status === 1001) {
        // 未登录或登录过期，踢回登录页
        Message.error(res.message || '登录已过期')
        localStorage.removeItem('access_token')
        redirectToLogin()
        return Promise.reject(new Error(res.message || '未登录'))
      } else {
        Message.error(res.message || '请求失败')
        return Promise.reject(new Error(res.message || '请求失败'))
      }
    }

    // 兼容 code 格式
    if (res.code !== undefined) {
      if (res.code === 200) {
        return res.data !== undefined ? res.data : res
      } else if (res.code === 401 || res.code === 403) {
        Message.error('登录已过期，请重新登录')
        localStorage.removeItem('access_token')
        redirectToLogin()
        return Promise.reject(new Error(res.msg || '认证失败'))
      } else {
        Message.error(res.msg || '请求失败')
        return Promise.reject(new Error(res.msg || '请求失败'))
      }
    }

    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      Message.error('登录已过期，请重新登录')
      localStorage.removeItem('access_token')
      redirectToLogin()
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default service
